
import React from 'react';
import { Chart } from 'primereact/chart';

const ExpenseAndAmount = ({ amount, expense }) => {

    var chartData = {
        labels: ["Faturamento", "Despesas"],
        datasets: [
            {
                data: [(amount || 0), (expense || 0)],
                backgroundColor: ['#5e35b1', '#1e88e5']
            }
        ]
    }

    let chartOptions = {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true
                }
            }
        }
    };

    return (
        <div className="col-5">
            <div className="card" style={{ height: "100%" }}>
                <h5>Faturamento Bruto x Despesa</h5>
                <Chart type="pie" className="w-full" data={chartData} options={chartOptions} />
            </div>
        </div>
    )
}

export default React.memo(ExpenseAndAmount);
